import { Theme, createTheme } from '@mui/material/styles';
import { ApplicationTheme } from '@tassat/payments-themes/dist/types/theme';

export interface ApplicationMuiTheme extends Theme {
    app: ApplicationTheme;
}

declare module '@mui/material/styles' {
    interface Theme {
        app: ApplicationTheme;
    }

    interface ThemeOptions {
        app?: ApplicationTheme;
    }
}

export const createMuiTheme = (applicationTheme: ApplicationTheme): ApplicationMuiTheme => createTheme({
    app: applicationTheme,
    typography: { fontFamily: '"corporate-s", sans-serif !important;' },
    components: {
        MuiButton: { styleOverrides: { root: { color: 'rgba(0, 0, 0, 0.87)' }}},
        MuiTab: {
            styleOverrides: {
                root: {
                    color: '#000',
                    opacity: 0.7,
                    '&.Mui-selected': {
                        color: '#000',
                        opacity: 1
                    },
                    '@media (min-width: 600px)': { minWidth: '160px' }
                }
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    border: 'none',
                    height: 1,
                    backgroundColor: 'rgba(0, 0, 0, 0.12)'
                }
            }
        },
        MuiLink: { defaultProps: { underline: 'hover' }}
    }
});